import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

function LastBlog({data}:any) {
    return ( 
        <div className="container-fluid py-3 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger text-uppercase">آخـریــن مـقــالات ما</h5>
                    {/* <h1 className="mb-0">آرخین مص</h1> */}
                </div>
                <div className="row g-4">

                    {data[0] && <div className="col-lg-5 wow slideInUp" data-wow-delay="0.6s">
                        <div className="card border-0">
                            <Link to={`/post/${data[0].id}/${data[0].title.replaceAll(' ', '-').toLowerCase()}`}><img src={data[0].image} className="card-img-top rounded img-fluid" style={{maxHeight: "350px"}} alt={data[0].title}/></Link>
                            <div className="card-body">
                                <Link to={`/post/${data[0].id}/${data[0].title.replaceAll(' ', '-').toLowerCase()}`}><h5 className="card-title text-danger">{data[0].title}</h5></Link>
                                <p className="card-text"><small className="text-body-secondary"><FontAwesomeIcon className="me-1" icon="icons"/>{data[0]?.BlogCategory?.name}</small></p>
                                <p className="card-text">{data[0].excerpt}</p>
                            </div>
                        </div>
                    </div>}

                    <div className="col-lg-7 wow slideInUp" data-wow-delay="0.6s">
                        {data.map((row:any,index:number) => index !== 0 &&
                        <div className="card mb-4 border-0" key={index}>
                            <div className="row g-0">
                                <div className="col-md-4" style={{maxHeight: "170px"}}>
                                    <Link to={`/post/${row.id}/${row.title.replaceAll(' ', '-').toLowerCase()}`}><img src={row.image} className="img-fluid rounded" style={{height: "100%", width: "100%"}} alt={row.title}/></Link>
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <Link to={`/post/${row.id}/${row.title.replaceAll(' ', '-').toLowerCase()}`}><h5 className="card-title text-danger">{row.title}</h5></Link>
                                        <p className="card-text"><small className="text-body-secondary"><FontAwesomeIcon className="me-1" icon="icons"/>{row?.BlogCategory?.name}</small></p>
                                        <p className="card-text">{row.excerpt}</p>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div>
        </div>
     );
}

export default LastBlog;